<template lang="pug">
  self-layout(:form.sync="form")
    template(#header)
      self-header
    template(#content)
      self-content
    template(#image)
      self-image
</template>

<script>
import { ref } from '@vue/composition-api'
import { page, injectRouteState } from '@iez/core'
import router from '@iez/core/router/'
import data from '@iez/lib/data/'
import user from '@iez/lib/user/'
import SelfLayout from './layout/'
import SelfHeader from './header/'
import SelfContent from './content/'
import SelfImage from './image/'
import { routeCurrent } from '@iez/core/router/'
import addPropertyIfExist from '@iez/lib/add-property-if-exists/'
import fromDataState from '@iez/lib/from-data-state/'
import createOnClick from '@iez/lib/create-on-click/'

const route = {
  path: '/post-create/:userId?/:postId?',
  name: 'PostCreate'
}

export default {
  ...route,

  components: {
    SelfLayout,
    SelfHeader,
    SelfContent,
    SelfImage
  },

  setup () {
    page.topBar.set(
      () => routeCurrent.params.postId
        ? {
          title: `Modification d'une publication`
        } : {
          title: `Création d'une publication`
        }
    )
    const form = ref(false)

    const fields = [
      `id`,
      `content`, {
        image: [
          `id`,
          `src`,
          `srcLazy`
        ]
      }
    ]
    const post = routeCurrent.params.postId
      ? data.get({
        root: `posts`,
        one: true,
        request: {
          where: {
            id: {
              _eq: routeCurrent.params.postId
            }
          }
        },
        fields
      }) : null

    const routeState = injectRouteState({
      shouldReset: true,
      payload: {
        dataState: fromDataState({
          getId: post
            ? () => post.value?.id
            : null,
          props: {
            content: {
              get: () => post.value?.content
            },
            image: {
              type: `image`,
              get: () => post.value?.image?.src
            }
          }
        }),
        me: data.me({
          fields: [
            'id',
            'name', {
              image: [
                `id`,
                `src`
              ]
            }
          ]
        })
      }
    })

    page.bottomAction.set(
      () =>
        form.value &&
        routeState.dataState.canMutate
          ? ({
            action: {
              label: post ? `Modifier` : `Publier`,
              onClick: createOnClick({
                onPublish: async () => {
                  await routeState.dataState.mutate({
                    root: `posts`,
                    additionalPayload: {
                      ...addPropertyIfExist({
                        name: `userId`,
                        value: routeCurrent.params.userId
                      }),
                      authorId: user.id
                    },
                    fields
                  })
                  router.push({
                    name: `Actualité`
                  })
                }
              })
            }
          }) : null
    )

    return {
      routeState,
      form,
      post
    }
  }
}
</script>
